import moment from 'moment';

const initialState = {
    top: 50,
    skip: 0,
    events: [],
    totalCount: 0,
    isLoading: false,
    dates: [],
    countries: [],
    states: [],
    statesToDisplay: [],
    filters: {},
};

function comparator(item1, item2) {
    if (item1.name < item2.name) {
        return -1;
    }
    if (item1.name > item2.name) {
        return 1;
    }
    return 0;
}
function dateComparator(item1, item2) {
    const date1 = moment().set('month', (item1.month - 1)).set('year', item1.year).startOf('month');
    const date2 = moment().set('month', (item2.month - 1)).set('year', item2.year).startOf('month');

    if (date1 < date2) {
        return -1;
    }
    if (date1 > date2) {
        return 1;
    }
    return 0;
}

function app(state = initialState, action) {
    switch (action.type) {
        case 'EVENTS:SEARCH_CRITERIA':
            return {
                ...state,
            };
        case 'EVENTS:SEARCH_CRITERIA_SUCCESS':
            return {
                ...state,
                dates: action.data.dates.sort(dateComparator),
                states: action.data.states.sort(comparator),
                countries: action.data.countries.sort(comparator),
            };
        case 'EVENTS:SEARCH_EVENTS':
            return {
                ...state,
                isLoading: true,
            };
        case 'EVENTS:SEARCH_EVENTS_SUCCESS':
            return {
                ...state,
                events: action.data.data,
                totalCount: action.data.total,
                isLoading: false,
            };
        case 'EVENTS:SEARCH_EVENTS_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'EVENTS:SET_PAGE': {
            const skip = state.skip + (action.direction * state.top);
            return {
                ...state,
                skip,
            };
        }
        case 'EVENTS:SET_PAGE_NUMBER': {
            const skipCount = (action.pageNumber * state.top);
            return {
                ...state,
                skip: skipCount,
            };
        }
        case 'EVENTS:CHANGE_FILTERS':
            return {
                ...state,
                filters: action.filters,
                skip: 0,
            };
        case 'EVENTS:UPDATE_DISPLAY_STATES':
            return {
                ...state,
                statesToDisplay: action.statesToDisplay,
            };
        default:
            return state;
    }
}

export default app;
